import { render, staticRenderFns } from "./PeersOverview.vue?vue&type=template&id=3a47050d&scoped=true"
import script from "./PeersOverview.vue?vue&type=script&lang=js"
export * from "./PeersOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47050d",
  null
  
)

export default component.exports